const MainWrapper = ({ children }: React.PropsWithChildren<{}>) => {
  return <div>{children}</div>;
};
export default MainWrapper;
